import { __awaiter } from "tslib";
import { createStore } from '@souche-f2e/muji';
import Api from '@/services';
import { judgeObj, judgeArr, dealValueShow, thousandBitSeparator } from '@/shared/functions';
const initState = {
    id: '',
    name: '',
    columns: [{
            title: '时间',
            dataIndex: 'createTime',
            width: 200,
        }, {
            title: '类型',
            dataIndex: 'operation',
            width: 150,
        }, {
            title: '状态',
            dataIndex: 'status',
            width: 150,
        }, {
            title: '金额(元)',
            dataIndex: 'money',
            width: 200,
        }, {
            title: '明细',
            dataIndex: 'detail',
            width: 300,
        }],
    data: [],
    totalNum: 0,
    options: [
        { label: '全部', value: '' },
        { label: '充值', value: '0' },
        { label: '提现', value: '4' },
        { label: '保证金冻结', value: '1' },
        { label: '保证金解冻', value: '2' },
        { label: '违约扣款', value: '3' },
    ],
    pageIndex: 1,
    pageSize: 20,
    params: {
        startDate: '',
        endDate: '',
        detailType: '',
    },
    tableLoading: false,
};
/**
 *  @desc 接口公共数据
 */
const _common = (data) => {
    const { i, v } = data;
    return {
        key: i,
        createTime: dealValueShow(v.createTime),
        operation: dealValueShow(v.operation),
        status: dealValueShow(v.status),
        money: dealValueShow(thousandBitSeparator(v.moneyY)),
        detail: dealValueShow(v.remark),
    };
};
export default createStore({
    state: Object.assign({}, initState),
    effects: {
        /** 加载 买家|卖家 明细列表 */
        load(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const { isSeller, id, tanantCode, name } = rootState.router.query;
                const { pageIndex, pageSize, params } = rootState.margin;
                const { startDate, endDate, detailType } = params;
                const _param = {
                    userId: id,
                    tanantCode,
                    currentIndex: pageIndex,
                    pageSize,
                    startDate,
                    endDate,
                    detailType,
                };
                // console.log('加载 买家端|卖家端 明细列表 _param', _param);
                this.SET_STATE({ tableLoading: true });
                let _r;
                if (isSeller === 'true') {
                    _r = yield this.sellerDetailData(_param);
                }
                else {
                    _r = yield this.buyerDetailData(_param);
                }
                this.SET_STATE({ tableLoading: false });
                // console.log(_r.items);
                this.SET_STATE({
                    data: _r.items,
                    totalNum: _r.totalNum,
                    id,
                    name,
                });
            });
        },
        /**
         * @desc 请求列表 卖家 明细列表
         */
        sellerDetailData(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                return Api.finance.sellerDepositDetailList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign({}, _common({ i, v }));
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
        /**
         * @desc 请求列表 买家 明细列表
         */
        buyerDetailData(payload, { update, state, rootState }) {
            return __awaiter(this, void 0, void 0, function* () {
                const result = { totalNum: 0, items: [] };
                return Api.finance.buyerDepositDetailList(payload).then((res) => {
                    const data = JSON.parse(JSON.stringify(res));
                    if (!judgeObj(data) || !judgeArr(data.items)) {
                        return result;
                    }
                    result.totalNum = data.totalNumber;
                    result.items = data.items.map((v, i) => {
                        const _item = Object.assign({}, _common({ i, v }));
                        return _item;
                    });
                    return result;
                }).catch((err) => {
                    console.log(err);
                    return result;
                });
            });
        },
    },
    reducers: {
        RESET_STATE() {
            return Object.assign({}, initState);
        },
        SET_STATE(state, payload) {
            Object.keys(payload)
                .forEach((key) => {
                if (initState[key] !== undefined) {
                    state[key] = payload[key];
                }
            });
        },
        SET_PARAMS(state, payload) {
            const { time, type } = payload;
            const _d = (time || []).map((t) => {
                return t.format('YYYY-MM-DD');
            });
            state.params = {
                startDate: _d[0] ? _d[0] : '',
                endDate: _d[1] ? _d[1] : '',
                detailType: type ? type : '',
            };
        },
        SET_PAGE_CURRENT(state, payload) {
            state.pageIndex = payload;
        },
    },
});
